import { playBillboardSound } from "@/hooks/use-sound-effects"

interface BillboardProps {
  onClick?: () => void
  isMobile?: boolean
  showBubble?: boolean
}

export const Billboard = ({ onClick, isMobile = false, showBubble = false }: BillboardProps) => {
  // 20% smaller on mobile: 160 * 0.8 = 128
  const size = isMobile ? 128 : 160

  const handleClick = () => {
    if (onClick) {
      playBillboardSound()
      onClick()
    }
  }

  return (
    <div
      className={`absolute left-0 z-30 drop-shadow-[0_0_40px_rgba(255,140,0,0.9)] ${onClick ? "cursor-pointer hover:brightness-110 transition-all" : ""}`}
      style={{
        top: "55%",
        transform: "translateY(-50%)",
      }}
      onClick={handleClick}
    >
      <img
        src="/images/billboard-front.png"
        alt="Billboard"
        width={size}
        height={size}
        className="w-auto h-auto"
        style={{ imageRendering: "pixelated" }}
      />
      {/* Tutorial bubble - z-50 to render above shop item cards (z-40) */}
      {showBubble && (
        <div
          className="absolute pointer-events-none transition-opacity duration-300 z-50"
          style={{
            left: "50%",
            top: "-8px",
            transform: "translateX(-50%) translateY(-100%)",
          }}
        >
          <div
            className="relative bg-black border border-white/50 rounded-lg px-3 py-2 text-white text-center whitespace-nowrap"
            style={{ fontSize: "12px" }}
          >
            <div>Quests & Leaderboard</div>
            {/* Diamond pointer pointing DOWN */}
            <div
              className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-3 h-3 bg-black border-r border-b border-white/50 rotate-45"
            />
          </div>
        </div>
      )}
    </div>
  )
}
